<template>
	<b-row>
		<b-col lg="8">
			<div v-for="group in displayGroups" :key="'group-'+ group.displayGroupId">
                <TerminalDisplayGroup :displayGroup="group" :terminalId="terminal.terminalId" :activeTerminalId="activeTerminalId"></TerminalDisplayGroup>
            </div>
		</b-col>
        <b-col>
            <card >
                <h6 class='h-i' @click="closeDisplayDetails"><i class="nc-icon nc-bank"></i><span>{{ terminal.name }}</span></h6>

                <div class="state-select">

                 <b-button :id="'popover-'+ terminal.terminalId" size="sm" variant="success" class='dd'>
                        <span>Normaalitila</span>
                        <b-icon v-if='showStateSelect' icon="caret-up-fill"></b-icon>
                        <b-icon v-else icon="caret-down-fill"></b-icon>
                </b-button>
                 <b-popover
                    :target="'popover-'+ terminal.terminalId"
                    placement="bottom"
                    :show.sync="showStateSelect">
                    <div class='popover-content'>
                        <b-form-group>
                            <b-form-radio v-for="option in stateOptions" :key="option.id" v-model="state"  :value="option.id">{{ option.label }}</b-form-radio>
                        </b-form-group>
                        <b-button variant="outline-danger" size="sm" @click="setState">Aseta terminaalin tila</b-button>
                    </div>
                </b-popover>
                </div>
            </card>

            <card id='display-details' v-if='displayDetails'>
                <!-- <CardHeader title="Näytön tiedot" close="true" @close="closeDisplayDetails"/> -->
                <TerminalDisplayDetails :terminalId="terminal.terminalId" :activeTerminalId="activeTerminalId" />
            </card>
            <div v-else>
                <!-- Might be a good idea to refetch depTransfers after switching from one terminal to another or something similar,
                    but this would probably have to happen on the 'TerminalView.vue' level. Unless refetching periodically. -->
                <DepartureTransfers :terminalId="terminal.terminalId" :activeTerminalId="activeTerminalId" />
                <card id='announcements'>
                    <TerminalAnnouncements :terminalId="terminal.terminalId" :activeTerminalId="activeTerminalId" />
                </card>

            </div>
        </b-col>
	</b-row>
</template>

<script>
import TerminalDisplayGroup from '@/components/Terminals/TerminalDisplayGroup.vue';
import TerminalDisplayDetails from '@/components/Terminals/TerminalDisplayDetails.vue';
import TerminalAnnouncements from '@/components/Terminals/TerminalAnnouncements.vue';
import DepartureTransfers from '@/components/Terminals/DepartureTransfers.vue';

export default {
	name: 'Terminal',
	components: {
		TerminalDisplayGroup, TerminalDisplayDetails, TerminalAnnouncements, DepartureTransfers
	},
    props: ['terminal', 'activeTerminalId'],
    data() {
        return {
            state: "1",
            stateOptions: [
                { id: '1', label: 'Normaali' },
                { id: '2', label: 'Ei liikennettä' },
                { id: '3', label: 'Palohälytys' },
            ],
            showStateSelect: false,
            states: null,
            screenshotUpdater: null
        };
    },
    watch: {
        terminal(){
            //console.log(this.terminal.terminalId)
            this.getStates();
        }
    },
    computed: {
        displayGroups(){
            return this.sortGroups(this.terminal.displayGroups);
        },

        displayDetails() {
            return this.$store.state.terminalView.selectedDisplay &&
                this.$store.state.terminalView.selectedDisplay.displayId;
        },


    },
    created() {
        this.getStates();

        this.screenshots();
    },


    methods: {
        closeDisplayDetails() {
            this.$store.commit('terminalView/setSelectedDisplay', {});
        },
        sortGroups(groups){
            return groups.sort((a, b) => {
                if (a.terminalDisplayGroupId < b.terminalDisplayGroupId)
                    return -1;
                if (b.terminalDisplayGroupId < a.terminalDisplayGroupId)
                    return 1;
                return 0;
            })
        },
        setState(){
            // todo
            this.showStateSelect = false;
        },
        getStates(){
            this.$traveller_http.get('/traveller/restui/terminals/getDisplayGroupStates', { params: { "terminalid": this.terminal.terminalId } })
            .then( response => {
                //console.log(response.data)
                this.states = response.data;
            })
            .catch( () => {} ) 
            .finally( () => {} ); 
        },
        screenshots(){
            clearTimeout(this.screenshotUpdater);
            this.$traveller_http.get('/traveller/restui/terminals/screenshots', { params: { "id": this.terminal.terminalId } })
            .then(() => {})
            .catch(() => {}) 
            .finally(() => {
                 this.screenshotUpdater = setTimeout(this.screenshots, 10000);  
            }); 
        }

    }
    
};
</script>
